import { useQuery } from '@tanstack/react-query';
import { JsonObject } from 'type-fest';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type { OpDefData } from './opDef/types/OpDefData';

export type ListOpDefsData = (OpDefData & JsonObject)[];

export type ListOpDefsParams = {
  groupId: number;
};

export type ListOpDefsQueryKey = readonly [
  'suppliers',
  ListOpDefsParams,
  'operation_definitions',
];

const getListOpDefsQueryKey = (
  params: ListOpDefsParams,
): ListOpDefsQueryKey => {
  return ['suppliers', params, 'operation_definitions'];
};

export const useListOpDefs: QueryFunction<
  ListOpDefsData,
  [ListOpDefsParams],
  ListOpDefsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getListOpDefsQueryKey(params);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/${params.groupId}/operation_definitions`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
